import { useAuthContext } from "../../../context/AuthContext";
import useBusinessCenterCompanyCreateRouteConfig from "../../../routes/configs/business_center_companies/BusinessCenterCompanyCreateRouteConfig";
import useBusinessCenterCompanyEditRouteConfig from "../../../routes/configs/business_center_companies/BusinessCenterCompanyEditRouteConfig";
import useBasicColumnConfig from "../main/config/column/default/BasicColumnConfig";
import useTimestampColumnConfig from "../main/config/column/default/TimestampColumnConfig";
import DataTableConfig from "../main/config/dataTable/DataTableConfig";
import useCreateHeaderActionConfig from "../main/config/headerAction/default/CreateHeaderActionConfig";
import useDeleteRowActionConfig from "../main/config/rowAction/default/DeleteRowActionConfig";
import useEditRowActionConfig from "../main/config/rowAction/default/EditRowActionConfig";
import DataTable, { useDataTable } from "../main/DataTable";

function BusinessCenterCompaniesDataTable() {
  const { auth } = useAuthContext();

  //Create the datatable config
  const config = new DataTableConfig("business_center_companies");

  //Set the datatable fetch info
  config.setFetchRequest("business_center_companies");
  config.setFetchParams({
    with_business_center_company_company_data: true,
    with_business_center_company_logo_data: true,
    with_business_center_company_terminal_data: true,
  });

  //Set default order
  config.setOrderBy("company.name");
  config.setOrderDirection("asc");

  //Set the datatable comuns
  config.setColumns([
    useBasicColumnConfig("company.name").setLockActive(true),
    useBasicColumnConfig("logo.name"),
    useBasicColumnConfig("terminal.name"),
    useTimestampColumnConfig("created_at"),
    useTimestampColumnConfig("updated_at"),
  ]);

  //Set the datatable row actions
  config.setRowActions([
    useEditRowActionConfig(
      "business_center_company",
      useBusinessCenterCompanyEditRouteConfig()
    ),
    useDeleteRowActionConfig("business_center_company").setDisabled(
      auth.user.role_type !== "superadmin"
    ),
  ]);

  //Set the datatable header actions
  config.setHeaderActions([
    useCreateHeaderActionConfig(
      "business_center_company",
      useBusinessCenterCompanyCreateRouteConfig()
    ),
  ]);

  //Create the datatable object
  const dataTable = useDataTable(config);

  return <DataTable controller={dataTable} />;
}

export default BusinessCenterCompaniesDataTable;
